import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-pdf-layout',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './pdf-layout.component.html',
  styleUrls: ['./pdf-layout.component.scss']
})
export class PdfLayoutComponent {}
